import { InjectionToken } from '@angular/core';
export interface BreadcrumbTranslations {
  ariaLabel: string;
}

export const defaultTranslations: BreadcrumbTranslations = {
  ariaLabel: 'breadcrumb'
};

export const BREADCRUMB_TRANSLATIONS = new InjectionToken<BreadcrumbTranslations>('BREADCRUMB_TRANSLATIONS');
